export const PaymentSuccessStyles = () => {
  return {
    wrapper: {
      padding: "60px 0 !important",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    content: {
      info: {
        maxWidth: "360px",
        textAlign: "center",
      },
    },
  };
};
